import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

interface AuditEntry {
  id: string;
  actor_id: string | null;
  action: string;
  target_type: string;
  target_id: string | null;
  payload: Record<string, unknown>;
  created_at: string;
}

export function AdminAuditLogPage() {
  const { data, isLoading, error } = useQuery<{ entries: AuditEntry[] }>({
    queryKey: ['audit-log'],
    queryFn: () => api('/api/admin/audit-log?limit=200'),
  });

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold">Audit Log</h1>
        <p className="text-ink-muted">Every admin action is recorded.</p>
      </header>

      {isLoading ? <p className="text-ink-muted">Loading…</p> : null}
      {error ? <p className="text-accent-danger">Failed to load audit log.</p> : null}

      <div className="card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-ink-muted">
            <tr>
              <th className="py-2">When</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Target</th>
              <th>Payload</th>
            </tr>
          </thead>
          <tbody>
            {(data?.entries ?? []).map((e) => (
              <tr key={e.id} className="border-t border-white/5">
                <td className="py-2 text-ink-muted">{new Date(e.created_at).toLocaleString()}</td>
                <td className="font-mono text-xs">{e.actor_id ?? '—'}</td>
                <td className="font-mono">{e.action}</td>
                <td className="font-mono text-xs">{e.target_type}{e.target_id ? `:${e.target_id}` : ''}</td>
                <td className="font-mono text-xs text-ink-muted">{JSON.stringify(e.payload)}</td>
              </tr>
            ))}
            {!(data?.entries ?? []).length ? (
              <tr><td colSpan={5} className="py-4 text-center text-ink-muted">No audit entries yet.</td></tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
